<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-13 13:10:38
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-05 10:58:25
 * @name: 额度设置
 * @Description: 额度设置
 * @FilePath: \preSaleNafterSaleBackstage\src\components\pianoCompanyManage\dialog\edit-limit.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <div>
    <addNeditDialog ref="addNeditDialog" title="额度设置" @close="close">
      <template v-slot:form>
        <div class="line">
          <font class="label"><i class="warn">*</i>最高额度:</font>
          <el-input
            class="input"
            v-model="form.limit"
            placeholder="请输入最高额度"
          ></el-input>
          <font class="append">元</font>
        </div>
      </template>
      <template v-slot:btnGroup>
        <el-button class="submit" type="primary" @click="submit"
          >确认</el-button
        >
      </template>
    </addNeditDialog>
  </div>
</template>
<script>
import addNeditDialog from "@/components/pianoCompanyManage/dialog/addNeditDialog.vue";
import { debounceation } from '@/utils/decorator';

export default {
  name: 'pianoCompanyManage-editLimit',
  components: {
    addNeditDialog,
  },
  data() {
    return {
      id: '', //琴行表格操作行id
      form: { //表单数据
        
      },
    }
  },
  computed: {
    // 验证最高额度是否已填
    limit_match() {
      return !this.form.limit || isNaN(this.form.limit);
    },
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 初始化data
     */    
    initData() {
      this.form = {
        limit: '',
      };
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 打开弹窗
     * @param {Number} id 琴行表格操作行id
     */    
    open(row) {
      this.initData();
      this.id = row.id || '';
      this.form.limit = row.credit_limit || '';
      this.$refs.addNeditDialog.open();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 关闭弹窗回调
     */    
    close() {
      this.id = '';
      this.initData();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 关闭弹窗
     */
    @debounceation(300)
    cancel() {
      this.$refs.addNeditDialog.close();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击确定
     */    
    @debounceation(300)
    submit() {
      if(this.limit_match) {
        this.$message.error("请输入最高额度,且须为数字");
        return;
      }
      this.$emit('editLimit', {id: this.id, form: this.form});
    },
  },
}
</script>
<style lang="scss" scoped>
.line {
  margin-bottom: 20px;
  width: 100%;
  height: $Var-height-mormal;
  @extend .extend-flex-start;
  .label {
    font-size: $Vars-font-miniTitle-size;
    color: $Vars-font-normal-color;
    width: 100px;
    text-align: left;
    flex-shrink: 0;
    position: relative;
    .warn {
      position: absolute;
      left: -10px;
      content: "*";
      color: red;
    }
  }
  .input {
    flex: 1;
  }
  .append {
    font-size: $Vars-font-miniTitle-size;
    color: $Vars-font-normal-color;
    padding: 0 20px;
    flex-shrink: 0;
  }
}
.submit {
  width: $Var-button-width-normal;
}
</style>